import axios from "axios";

console.log(
  "API BASE URL:",
  process.env.REACT_APP_API_BASE_URL
);

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 1500000,
});

export const postJsonData = (
  endpoint,
  jsonData,
  setIsProgress,
  onSuccess,
  onError
) => {
  if (setIsProgress) setIsProgress(true);

  return axiosInstance
    .post(endpoint, jsonData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      if (onSuccess) {
        onSuccess(response);
      }

      return response;
    })
    .catch((error) => {
      if (onError) {
        onError(error);
      }

      throw error;
    })
    .finally(() => {
      if (setIsProgress) setIsProgress(false);
    });
};

export const postFormData = (
  endpoint,
  formData,
  setIsProgress,
  onSuccess,
  onError
) => {
  if (setIsProgress) setIsProgress(true);

  return axiosInstance
    .post(endpoint, formData)
    .then((response) => {
      if (onSuccess) {
        onSuccess(response);
      }

      return response;
    })
    .catch((error) => {
      if (onError) {
        onError(error);
      }

      throw error;
    })
    .finally(() => {
      if (setIsProgress) setIsProgress(false);
    });
};

export const getJsonData = (
  endpoint,
  setIsProgress,
  onSuccess,
  onError
) => {
  if (setIsProgress) setIsProgress(true);

  return axiosInstance
    .get(endpoint)
    .then((response) => {
      if (onSuccess) {
        onSuccess(response);
      }

      return response;
    })
    .catch((error) => {
      if (onError) {
        onError(error);
      }

      throw error;
    })
    .finally(() => {
      if (setIsProgress) setIsProgress(false);
    });
};

export default axiosInstance;